import CardWithText from './card_with_text';

export default CardWithText;
